// extracted by mini-css-extract-plugin
export default {"item":"ReleaseListItem_item__MiOlL","categoryTag":"ReleaseListItem_categoryTag__-OJ1X"};